import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectPrefersUnifiedInbox = createBasicSelector(state =>
  selectBooleanPreferenceByName(state, 'unified_inbox')
)
